export default {
  baseStyle: {
    container: {
      border: "0",
      bg: "paleGrey.500",
    },
    button: {
      color: "paleGrey.500",
      bg: "dullBrown.500",
      fontWeight: "semibold",
      textTransform: "uppercase",
      _focus: {
        boxShadow: "none",
      },
      _hover: {
        bg: "dullBrown.500",
      },
    },
  },
}
